export default "__VITE_ASSET__D7JKVvG0__"